import(/* webpackMode: "eager" */ "/home/briar/git/DLOM-2-serverless/frontend/app/support/page.tsx");
